import NiceModal from "@ebay/nice-modal-react";
import { ProductConfiguratorModal } from "objs/_ConfiguratorObjs/Wizard/ProductConfiguratorModal/ProductConfiguratorModal";

export function productNavigationHandler({
  product,
  isModalActive,
  id,
  dummy,
  type,
  wizardType,
  handleBackAction,
  modal,
  setProductCategoryId,
  navigateToConfiguratorPage,
  projectId,
  navigateToProductListPage,
  setQuery,
  setCategoryHeadline,
  findSeriesKeylistByKey,
  seriesMap,
  productCategoryId,
  findCategoryByName,
  groupPosition,
}) {
  const {
    link,
    nodes,
    serieId,
    seriesId,
    name,
    serie,
    key,
    parentName,
    parentCategories,
  } = product;

  if (link) {
    const url = link.get("linkForMenuItem").url();
    window.open(url, "_blank");
    return;
  }

  if (!nodes) {
    if (isModalActive) {
      NiceModal.show(ProductConfiguratorModal, {
        id,
        orderCode: { seriesId: seriesId || serieId },
        title: name,
        handleBackAction,
        dummy,
        wizardType,
        groupPosition,
        type,
        forceLoadDefault: true,
      });
      if (modal && typeof modal.remove === "function") {
        modal.remove();
      }
    } else {
      if (setQuery) {
        setQuery("");
      }
      if (setCategoryHeadline) {
        setCategoryHeadline(parentName);
      }

      const selectedSerieId = serieId;
      if (findSeriesKeylistByKey) {
        setProductCategoryId(
          findSeriesKeylistByKey({ seriesMap, targetKey: key }),
        );
      } else {
        setProductCategoryId(product.keyList);
      }

      if ((selectedSerieId && product.isSerie) || (selectedSerieId && serie)) {
        navigateToConfiguratorPage({
          seriesId: selectedSerieId.toString(),
          selectedCategory: productCategoryId,
          projectId,
          shouldKeepProductCategories: true,
        });
      } else {
        if (findCategoryByName) {
          setProductCategoryId(findCategoryByName(parentCategories)?.class);
        }
        navigateToProductListPage({
          projectId,
          shouldKeepProductCategories: true,
        });
      }
    }
  } else {
    if (setProductCategoryId && product.keyList) {
      setProductCategoryId(product.keyList);
    }
    navigateToProductListPage({
      projectId,
      shouldKeepProductCategories: true,
    });
  }
}
